import React from "react";
import {Outlet} from "react-router-dom";
import SettingNavTab from "./SettingNavTab";

function Settings() {

    return (
        <section className="section-bg-color setting_tab px-2"
                 style={{minHeight: "calc(100vh - 139px)", overflowX: "hidden", marginTop:"6.6vh"}}>
            <div className="custom_container">
                <div className="row">
                    <SettingNavTab />

                    <div className="col-md-9">
                        <div className="tab-content bg_transparent" id="nav-tabContent"
                             style={{minHeight: "calc(100vh - 137px)", marginBottom: 30}}>

                            <Outlet/>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Settings;